<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/virtual.mp4"></video>
      <p class="description pd-top-40">
        MNC Pictures dengan program Klaklik mempersembahkan rangkaian Virtual Fun Hangout dengan para talent dari series favorit, yaitu Ikatan Cinta, Amanah Wali, Putri Untuk Pangeran, IPA-IPS, Meraih Bintang, mulai dari 28 Oktober sampai 5 November 2021, serta melibatkan interaksi viewers dari masing-masing fanbase maupun kalangan umum.
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Virtual',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/virtual-hangout')
    }
  }
}
</script>
